import { CommonFragments } from './common.fragments';

export class TotalReturnsFragments {
  /*
   * Fragment for the Current Year Periods
   */
  private static readonly currentYearPeriodsFragment = `
    oneMonth
    threeMonth
    yearToDate
  `;

  private static readonly currentYearPeriodsPerformanceFragment = `
    effectiveDate
    pureGross {
      ${TotalReturnsFragments.currentYearPeriodsFragment}
    }
    net {
      ${TotalReturnsFragments.currentYearPeriodsFragment}
    }
    benchmark {
      ${TotalReturnsFragments.currentYearPeriodsFragment}
    }
    pureGrossValueAdded {
      ${TotalReturnsFragments.currentYearPeriodsFragment}
    }
    netValueAdded {
      ${TotalReturnsFragments.currentYearPeriodsFragment}
    }
  `;

  /*
   * Fragments for the Annualized Periods
   */
  private static readonly annualizedPeriodsFragment = `
    oneYear
    threeYear
    fiveYear
    tenYear
    sinceInception
  `;

  private static readonly annualizedPeriodsPerformanceFragment = `
    effectiveDate
    pureGross {
      ${TotalReturnsFragments.annualizedPeriodsFragment}
    }
    net {
      ${TotalReturnsFragments.annualizedPeriodsFragment}
    }
    benchmark {
      ${TotalReturnsFragments.annualizedPeriodsFragment}
    }
    pureGrossValueAdded {
      ${TotalReturnsFragments.annualizedPeriodsFragment}
    }
    netValueAdded {
      ${TotalReturnsFragments.annualizedPeriodsFragment}
    }
  `;

  /*
   * GraphQL Fragment for the Current Year Performance Exhibit
   */
  public static readonly currentYearPerformanceFragment = `
    currentYearSummaryExhibit {
      monthEnd {
        ${TotalReturnsFragments.currentYearPeriodsPerformanceFragment}
      }
      ${CommonFragments.disclaimerFragment}
    }
  `;

  /*
   * GraphQL Fragment for the Annualized Performance Exhibit
   */
  public static readonly annualizedPerformanceFragment = `
    annualizedSummaryExhibit {
      benchmarkName
  		portfolioInceptionDate
  		productName
      monthEnd {
        ${TotalReturnsFragments.annualizedPeriodsPerformanceFragment}
      }
      quarterEnd {
        ${TotalReturnsFragments.annualizedPeriodsPerformanceFragment}
      }
      ${CommonFragments.disclaimerFragment}
    }
  `;

  /*
   * GraphQL Fragment for the Calendar Year Performance Exhibit
   */

  public static readonly calendarYearPerformanceFragment = `
    calendarYearSummaryExhibit {
      benchmarkName
      effectiveDate
      values {
        benchmark
        endDate
        marketPrice
        nav
        netValueAdded
        pureGrossValueAdded
        year
      }
      ${CommonFragments.disclaimerFragment}
    }
  `;

  /*
   * GraphQL Fragment for the Total Returns Exhibit
   * Note: Since we have three separate exhibits we combine them into one fragment
   */
  public static readonly TotalReturnsFragment = `
      metadata {
        assetTypeName
      }
      ${TotalReturnsFragments.annualizedPerformanceFragment}
      ${TotalReturnsFragments.currentYearPerformanceFragment}
      ${TotalReturnsFragments.calendarYearPerformanceFragment}
  `;
}
